import React, { useState, useRef, useEffect } from 'react'
import {
    Button, Typography, Alert, QRCode, Flex, Table, Badge, Tabs, Drawer, Form,
    Checkbox, Input, Upload, Select, Card, Divider, InputNumber, Tag, Tooltip, Skeleton,
    Breadcrumb,
    Image,
    DatePicker, ConfigProvider
} from 'antd'
import api, { BASEURL } from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import ReactToPrint from 'react-to-print';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import {
    CloseOutlined,
    UploadOutlined,
    FileTextOutlined,
    DownloadOutlined,
    FilePdfFilled
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import InputMask from 'react-input-mask';
import { cnpj, cpf, validator } from 'cpf-cnpj-validator'
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import BAIXACRT from '../../../images/baixa.png'
import GOVBR from '../../../images/gov.png'
import locale from 'antd/locale/pt_BR';


export const CRTBaixadas = (props) => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [msg, setMsg] = useState('')
    const { addToast } = useToasts()
    const [dataMinhasCRT, setDataMinhasCRT] = useState(undefined)
    const [dataSolicitacoes, setDataSolicitacoes] = useState(undefined)
    const [user, setUser] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [CNPJ, setCNPJ] = useState('10.260.249/0003-51')
    const [selected, setSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [solicitacao, setSolicitacao] = useState({
        formapagamento: 0,
        crq: user?.crq,
        vinculo: 0,
        nome: user?.nome,
        cpf: user?.cpf,
        horas: 2,
        atividade: "Responsável Técnico da Empresa.",
        anexo: false,
        firma: {

        }
    })

    const [fileList, setFileList] = useState([]);
    const [dataBaixa, setDataBaixa] = useState(dayjs())


    useEffect(() => {
        console.log(user)
        if (user?.isprofissional === 1)
            getMinhasCRTs()
        else
            navigate('/login')
    }, [])


    async function getMinhasCRTs() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/minhas-crt/baixadas',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            console.log(result.data)
            setDataMinhasCRT(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }



    function renderComunicacoes() {
        return <Flex vertical gap={5}>
            <Flex justify='flex-end'>

            </Flex>
            <Table id='tablesmall2' size='small' bordered pagination={false} dataSource={dataMinhasCRT} loading={loading}
                defaultExpandAllRows={true}>
                <Table.Column hidden={isMobile} title={"Processo"} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }}>{item.processo}</Flex>
                }} />

                <Table.Column title={"Razão Social"} render={(txt, item, index) => {
                    return <Flex gap={5} align='center'>
                        <Flex style={{ fontSize: '0.9em' }}>{item.razao}</Flex>                        
                    </Flex>
                }} />
                <Table.Column hidden={isMobile} title={"CNPJ"} align='center' width={130} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{item.cnpj}</Flex>
                }} />

                <Table.Column title={"Data da Baixa"} align='center' render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{dayjs(item.databaixa).format('DD/MM/YYYY')}</Flex>
                }} />
            
              

            </Table>
        </Flex>
    }






    return <Flex vertical gap={10}>

        <Breadcrumb items={[
            {
                title: <Flex align='center' gap={5}><FileTextOutlined /> Comunicações de Responsabilidade Técnica</Flex>,
            }, {
                title: "Baixadas (".concat(dataMinhasCRT ? dataMinhasCRT?.length : '', ')')
            }
        ]} />

        {renderComunicacoes()}

     

    </Flex>

}